export enum CurrencySymbolPosition {
    Prefix = 'Prefix',
    Suffix = 'Suffix',
}
